document.querySelectorAll("global-header #menu>ul>li").forEach(li => {
	let ul = li.querySelector("ul");
	if(!ul) {
		return;
	}

	li.addEventListener("mouseenter", mouseOver);
	li.addEventListener("mouseleave", mouseLeave);

	function mouseOver(e) {
		ul.classList.add("hover");
	}

	function mouseLeave(e) {
		ul.classList.remove("hover");
	}
});
